import { legacy_createStore } from "redux";
import allReducers from "./reducers";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, allReducers)

const store = legacy_createStore(persistedReducer);
store.getState();
let persistor = persistStore(store);
export { store, persistor };
